export function addCpfCnpjMask(input: string) {
  if (!input) return input;

  let result = input.replace(/[.\-\/\s]+/g, '').toUpperCase();

  if (result.length === 11 && /^\d{11}$/.test(result)) {
    //CPF (apenas numérico)
    result = result.replace(/(\d{3})(\d)/, '$1.$2');
    result = result.replace(/(\d{3})(\d)/, '$1.$2');
    result = result.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  } else if (result.length === 14) {
    //CNPJ (alfanumérico ou numérico): XX.XXX.XXX/XXXX-XX
    result = result.replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2');
    result = result.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3');
    result = result.replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2');
    result = result.replace(/\/([A-Z0-9]{4})([0-9])/, '/$1-$2');
  }

  return result;
}

export function addTelefoneMask(input: string) {
  let result = input?.replace(/\D/g, '');

  if (result?.length !== 11 && result?.length !== 10) {
    return input;
  }

  result = result.replace(/(\d{2})(\d)/, '$1 $2');
  if (result.length === 11) {
    result = result.replace(/(\d{4})(\d)/, '$1-$2');
  } else {
    result = result.replace(/(\d{5})(\d)/, '$1-$2');
  }

  return result;
}

export function addCEPMask(input: string) {
  let result = input?.replace(/\D/g, '');

  if (result?.length !== 8) {
    return input;
  }

  result = result.replace(/(\d{5})(\d)/, '$1-$2');

  return result;
}
